import ReactivateMembership, {
	IReactivateMembershipPageContent,
} from './ReactivateMembership.component';
import ReactivateMembershipPage from './ReactivateMembership.page';

export default ReactivateMembershipPage;

export { ReactivateMembership };
export type { IReactivateMembershipPageContent };
